import { useState } from 'react';
import '../styles/inner.css';

export default function Contact() {
  const [sent, setSent] = useState(false);
  const [form, setForm] = useState({ name:'', email:'', subject:'', message:'' });

  const handle = e => setForm({...form, [e.target.name]: e.target.value});
  const submit = e => { e.preventDefault(); setSent(true); };

  return (
    <>
      {/* Contact banner using the GET IN TOUCH image */}
      <div
        className="inner-banner contact"
        style={{
          backgroundImage: 'url(/images/contact-us.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
      >
        <div className="container">
          <h1>Contact Us</h1>
          <div className="sep" />
          <h4>Providing cutting edge IT solutions in the best way at the right time</h4>
        </div>
      </div>

      <div className="contact-page">
        <div className="container">
          <div className="locations-wrapper">
            {/* India map placeholder */}
           {/* India map */}
<div className="map-img-box">
  <img src="/images/map.jpg" alt="India Map - Levante Logistics Locations" />
</div>

            <div className="locations-info">
              <h3>Our Locations</h3>
              <h4>Our Global Presence</h4>
              <h4>Head Office</h4>
              <div className="city-name">New Delhi</div>
              <div className="company-name">Matrix Processing House</div>
              <div className="addr-line">
                <i className="fa fa-map-marker" />
                <span>
                  8/42, 2nd Floor, Kirti Nagar Industrial<br/>
                  Area, Opp. Johnson and Johnson,<br/>
                  NEW DELHI - 110 015<br/>
                  Call Us On #: 91-11-45024329<br/>
                  Or E-mail us at:<br/>
                  info@levantelogistic.com
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}